import React, { PureComponent } from 'react';
import {
SelectField,
  Button,
  DialogContainer,
  Divider,
  TextField,
  Toolbar,
} from 'react-md';

export default class AddRunConfigurationDialog extends PureComponent {
  state = { visible: false, pageX: null, pageY: null };
  show = (e) => {
    // provide a pageX/pageY to the dialog when making visible to make the
    // dialog "appear" from that x/y coordinate
    let { pageX, pageY } = e;
    if (e.changedTouches) {
      pageX = e.changedTouches[0].pageX;
      pageY = e.changedTouches[0].pageY;
    }

    this.setState({ visible: true, pageX, pageY });
  };

  hide = () => {
    this.props.hideAddRowDialog();
  };

    add = () => {
      this.props.addProject("Aloooo");
    };


      handleSubmit = (e) => {

        const newDessert = this.parseNewDesserts(e);
        this.props.addProject(newDessert);

      };

    parseNewDesserts = e => [].reduce.call(e.target.elements, (desserts, el) => {
        const {id, name, type, value, checked } = el;
        if (!id) { // buttons
          return desserts;
        }

        //alert(id + ": " + this.state.email);


       // dessert = {"name" : value};
       const dessert = desserts[0] || { id: 1, isNew: true };

        dessert[id] = value;

        desserts[0] = dessert;
        return desserts;
      }, {});

  render() {
    const { pageX, pageY } = this.state;
    const { visible } = this.props;
  //alert("ddddddddddddddddd: " + visible);
    var aa = visible ? "visible" : "";

    const OPERATING_SYSTEMS = [{
      label: 'Windows',
      value: 'A',
    }, {
      label: 'Linux',
      value: 'B',
    }, {
      label: 'MAc',
      value: 'C',
    }];

     const BROWSERS = [{
          label: 'Firefox',
          value: 'A',
        }, {
          label: 'Chrome',
          value: 'B',
        }, {
          label: 'Internet Explorer',
          value: 'C',
        }, {
          label: 'Opera',
          value: 'D',
        }, {
          label: 'Safari',
          value: 'E',
        }];

    return (
      <div>

      {visible}
<form className="md-grid text-fields__application" onSubmit={this.handleSubmit}>

        <DialogContainer
          id="simple-full-page-dialog"
          visible={visible}
          pageX={pageX}
          pageY={pageY}
          fullPage
          onHide={this.hide}
          aria-labelledby="simple-full-page-dialog-title"
        >
          <Toolbar
            fixed
            colored
            title="New Run Configuration"
            titleId="simple-full-page-dialog-title"
            nav={<Button icon onClick={this.hide}>close</Button>}
            actions={<Button type="submit" flat>Save</Button>}
          />
          <section className="md-toolbar-relative">

            <TextField id="name" placeholder="Name" block paddedBlock />
            <Divider />
            <SelectField
                 id="select-field-5"
                 placeholder="operatingSystem"
                 className="md-cell"
                 menuItems={OPERATING_SYSTEMS}
                 position={SelectField.Positions.BELOW}
               />
            <Divider />
             <SelectField
                 id="select-field-5"
                 placeholder="browser"
                 className="md-cell"
                 menuItems={BROWSERS}
                 position={SelectField.Positions.BELOW}
               />
          </section>
        </DialogContainer>
        </form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Project/Detail/RunConfiguration/AddRunConfigurationDialog.js